/* eslint-disable id-length */
import keyMirror from 'keymirror';

export default keyMirror({
  CALENDAR_SECTION_TITLE_RENDERED: null,
  CALENDAR_SECTION_INTRO_RENDERED: null,
  CALENDAR_RENDERED: null,
  CALENDAR_SMALLER_SCREEN_CONTAINER: null,
  CALENDAR_BIGGER_SCREEN_CONTAINER: null,
  CALENDAR_EVENT_DAY: null,
  CALENDAR_EVENT_DATE: null,
  CALENDAR_EVENT_TIME: null,
  CALENDAR_DESC: null,
  CALENDAR_DESC_BEGINNING: null,
  CALENDAR_DESC_ELIPSIS: null,
  CALENDAR_DESC_EXPAND: null,
  CALENDAR_DESC_TEXT: null,
  CALENDAR_SHOW_NEXT_EVENTS: null,
  CALENDAR_SHOW_PREV_EVENTS: null,
  CALENDAR_EVENT_NAVIGATION: null,
  CALENDAR_NO_EVENT_MSG: null
});
